import { IMetaData } from '../interfaces/meta-data.interface';

/**
 * SEO Meta tags configuration for each route
 * Uses translation keys that will be resolved by MetasService
 */
export const SEO_META_TAGS: Record<string, IMetaData> = {
  home: {
    title: 'SEO.HOME.TITLE',
    description: 'SEO.HOME.DESCRIPTION',
    keywords: 'SEO.HOME.KEYWORDS',
    url: '/home',
    image: 'https://braidsbook.com/images/smiling-woman-holding-afro-picks.webp',
    type: 'website'
  },
  hairdressers: {
    title: 'SEO.HAIRDRESSERS.TITLE',
    description: 'SEO.HAIRDRESSERS.DESCRIPTION',
    keywords: 'SEO.HAIRDRESSERS.KEYWORDS',
    url: '/hairdressers',
    image: 'https://braidsbook.com/images/portrait-woman-red-scarf.webp',
    type: 'website'
  },
  hairstyles: {
    title: 'SEO.HAIRSTYLES.TITLE',
    description: 'SEO.HAIRSTYLES.DESCRIPTION',
    keywords: 'SEO.HAIRSTYLES.KEYWORDS',
    url: '/hairstyles',
    image: 'https://braidsbook.com/images/og-hairstyles.webp',
    type: 'website'
  },
  auth: {
    title: 'SEO.AUTH.TITLE',
    description: 'SEO.AUTH.DESCRIPTION',
    keywords: 'SEO.AUTH.KEYWORDS',
    url: '/auth',
    image: 'https://braidsbook.com/images/og-auth.webp',
    type: 'website'
  },
  terms: {
    title: 'SEO.TERMS.TITLE',
    description: 'SEO.TERMS.DESCRIPTION',
    keywords: 'SEO.TERMS.KEYWORDS',
    url: '/terms',
    image: 'https://braidsbook.com/images/og-terms.jpg',
    type: 'website'
  },
  privacy: {
    title: 'SEO.PRIVACY.TITLE',
    description: 'SEO.PRIVACY.DESCRIPTION',
    keywords: 'SEO.PRIVACY.KEYWORDS',
    url: '/privacy',
    image: 'https://braidsbook.com/images/og-privacy.jpg',
    type: 'website'
  },
  reviews: {
    title: 'SEO.REVIEWS.TITLE',
    description: 'SEO.REVIEWS.DESCRIPTION',
    keywords: 'SEO.REVIEWS.KEYWORDS',
    url: '/reviews',
    image: 'https://braidsbook.com/images/og-reviews.jpg',
    type: 'website'
  },
  'delete-account': {
    title: 'SEO.DELETE_ACCOUNT.TITLE',
    description: 'SEO.DELETE_ACCOUNT.DESCRIPTION',
    keywords: 'SEO.DELETE_ACCOUNT.KEYWORDS',
    url: '/delete-account',
    image: 'https://braidsbook.com/images/og-privacy.jpg',
    type: 'website'
  },
  directory: {
    title: 'SEO.DIRECTORY.TITLE',
    description: 'SEO.DIRECTORY.DESCRIPTION',
    keywords: 'SEO.DIRECTORY.KEYWORDS',
    url: '/directory',
    robots: 'noindex, follow'
  },
  'hairdresser-details': {
    title: 'SEO.HAIRDRESSER_DETAILS.TITLE',
    description: 'SEO.HAIRDRESSER_DETAILS.DESCRIPTION',
    keywords: 'SEO.HAIRDRESSER_DETAILS.KEYWORDS',
    url: '/hairdressers',
    type: 'profile'
  },
  'hairstyle-details': {
    title: 'SEO.HAIRSTYLE_DETAILS.TITLE',
    description: 'SEO.HAIRSTYLE_DETAILS.DESCRIPTION',
    keywords: 'SEO.HAIRSTYLE_DETAILS.KEYWORDS',
    url: '/hairstyles',
    type: 'article'
  },
  shop: {
    title: 'SEO.SHOP.TITLE',
    description: 'SEO.SHOP.DESCRIPTION',
    keywords: 'SEO.SHOP.KEYWORDS',
    url: '/boutique',
    image: 'https://braidsbook.com/images/og-hairstyles.webp',
    type: 'website'
  },
  'product-details': {
    title: 'SEO.PRODUCT_DETAILS.TITLE',
    description: 'SEO.PRODUCT_DETAILS.DESCRIPTION',
    keywords: 'SEO.PRODUCT_DETAILS.KEYWORDS',
    url: '/boutique',
    type: 'website'
  },
  'quick-booking': {
    title: 'SEO.QUICK_BOOKING.TITLE',
    description: 'SEO.QUICK_BOOKING.DESCRIPTION',
    keywords: 'SEO.QUICK_BOOKING.KEYWORDS',
    url: '/book',
    type: 'website'
  }
};

/**
 * Get SEO meta data for a specific route
 * @param routeName - Name of the route (key in SEO_META_TAGS)
 * @param customData - Optional custom data to override defaults
 */
export function getSEOMetaData(routeName: string, customData?: Partial<IMetaData>): IMetaData | null {
  const baseData = SEO_META_TAGS[routeName];
  if (!baseData) {
    return null;
  }

  return customData ? { ...baseData, ...customData } : baseData;
}

